import { WhatsappSession, WhatsappSessionState } from "../../../interfaces/WhatsappSessions.interfaces";

export const STATE_LABELS: Record<WhatsappSessionState, string> = {
    CONNECTED: "Conectado",
    QR_PENDING: "Aguardando QR code",
    STARTING: "Conectando",
    DISCONNECTED: "Desconectado",
};

// Instances without the session fields (WWEBJS or an outdated wa-client-lite) only report flags.
export function getSessionState(session: WhatsappSession): WhatsappSessionState {
    if (session.state) return session.state;
    if (session.ready) return "CONNECTED";
    if (session.auth) return "STARTING";

    return "DISCONNECTED";
};

const pad = (value: number) => String(value).padStart(2, "0");

export function formatDateTime(iso?: string | null): string {
    if (!iso) return "—";

    const date = new Date(iso);

    if (Number.isNaN(date.getTime())) return "—";

    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export function formatTime(iso?: string | null): string {
    if (!iso) return "—";

    const date = new Date(iso);

    if (Number.isNaN(date.getTime())) return "—";

    return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export function formatDuration(milliseconds: number): string {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) return `${days}d ${hours}h ${minutes}min`;
    if (hours > 0) return `${hours}h ${minutes}min`;
    if (minutes > 0) return `${minutes}min ${seconds}s`;

    return `${seconds}s`;
};

export function formatElapsed(iso: string | null | undefined, now: number): string {
    if (!iso) return "—";

    const elapsed = now - new Date(iso).getTime();

    if (Number.isNaN(elapsed)) return "—";
    if (elapsed < 60_000) return "agora há pouco";

    const minutes = Math.floor(elapsed / 60_000);
    if (minutes < 60) return `há ${minutes} min`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `há ${hours} h`;

    const days = Math.floor(hours / 24);

    return days === 1 ? "há 1 dia" : `há ${days} dias`;
};
